/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative}.margin-left[_ngcontent-%COMP%]{margin-left:15px}.displaimer[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:5px}.displaimer[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:1.35rem;color:#009688;width:1.35rem;height:1.35rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/studentinfo/studentinfo.component.css.shim.ngstyle.js.pre-build-optimizer.js